
import { defineComponent } from 'vue'
import Dialog from 'primevue/dialog'

export default defineComponent({
    name: 'olap-custom-view-save-dialog',
    components: { Dialog },
    props: { sqlData: Object, visible: Boolean },
    data() {
        return {
            sqlFormats: {} as any
        }
    },
    watch: {
        sqlData() {
            this.sqlFormats = this.sqlData
        }
    },
    created() {
        this.sqlFormats = this.sqlData
    },
    methods: {}
})
